var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDryFood = function SvgDryFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 5.025c-1.29-.007-1.945.735-1.949 1.654-.004.919.643 1.668 1.934 1.675.903.005 2.367-.802 3.164-1.286.252-.154.254-.563.003-.72-.793-.494-2.249-1.317-3.152-1.323z",
    fill: "#A4E869"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.684 6.29a1.804 1.804 0 00-.043.389c-.004.919.643 1.668 1.934 1.675.903.005 2.367-.802 3.164-1.286.252-.154.254-.563.003-.72l-.047-.03c-.806.488-2.23 1.263-3.116 1.258-1.103-.006-1.736-.553-1.895-1.286z",
    fill: "#54CE3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93 5.206s.223-.246.638-.514a4.228 4.228 0 011.844-.657c1.572-.168 2.066-2.116 3.012-2.032.945.083.808.763 2.245 1.262 1.103.383 1.926.72 2.366 1.315.134.18.233.386.293.624.257 1.018-7.138 3.67-10.398.002z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93 5.207s.223-.246.638-.515c.526.16 1.488.413 2.697.564.67.083 1.35.125 2.018.125 1.701 0 3.3-.27 4.752-.8.134.18.233.385.293.623.257 1.019-7.138 3.67-10.398.003z",
    fill: "#EFCDB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.938 15.272c-.267.374-.98.32-1.591-.12a2.243 2.243 0 01-.209-.17c-1.06.518-2.592.837-4.764.837-2.356 0-4.003-.373-5.133-.967-.097.106-.21.208-.337.3-.612.44-1.325.494-1.592.12-.263-.368.005-1.015.599-1.455-1.502-1.761-.83-4.267-.22-5.733.3-.725.587-1.196.587-1.196l11.176-.054s.406.566.831 1.413c.773 1.538 1.611 4.002.213 5.7.48.43.678.991.44 1.325z",
    fill: "url(#Dry_Food_svg__paint0_linear_1120_204816)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.285 8.247a1.527 1.527 0 01-.112.048c-1.825.686-3.806 1.033-5.886 1.033-3.488 0-6.113-.995-6.223-1.037a1.59 1.59 0 01-.374-.207c.301-.725.587-1.196.587-1.196l11.176-.054s.406.566.832 1.413z",
    fill: "url(#Dry_Food_svg__paint1_linear_1120_204816)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.225 12.114H8.02c-.266 0-.485-.23-.508-.53-.066-.864-.016-1.771.048-2.453.062-.652.137-1.097.137-1.097l4.848-.106c.08.354.13.786.161 1.236.06.875.046 1.817.027 2.396-.01.31-.235.554-.51.554z",
    fill: "url(#Dry_Food_svg__paint2_linear_1120_204816)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.707 9.165c-.789.108-1.596.163-2.42.163-.99 0-1.912-.08-2.726-.197.062-.652.137-1.097.137-1.097l4.848-.106c.08.355.13.786.161 1.237z",
    fill: "url(#Dry_Food_svg__paint3_linear_1120_204816)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.288 8.633c-3.367 0-5.868-.941-6.024-1.001-.566-.218-.876-.938-.691-1.607.184-.67.791-1.036 1.357-.819.013.005 1.325.5 3.268.74 1.767.22 4.438.269 7.13-.742.567-.213 1.174.158 1.354.83.18.67-.134 1.388-.702 1.6-1.992.749-3.957.999-5.692.999z",
    fill: "#F9E8D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 4.564c-.165 0-.3-.153-.3-.34v-.038c0-.188.135-.34.3-.34.167 0 .301.152.301.34v.038c0 .187-.134.34-.3.34zM11.15 4.651c-.166 0-.3-.152-.3-.34v-.038c0-.187.134-.34.3-.34.166 0 .301.153.301.34v.039c0 .187-.135.34-.3.34zM10.425 3.689c-.166 0-.3-.153-.3-.34V3.31c0-.188.134-.34.3-.34.166 0 .3.152.3.34v.038c0 .187-.134.34-.3.34zM9.592 4.734c-.166 0-.301-.152-.301-.34v-.038c0-.187.135-.34.3-.34.167 0 .302.153.302.34v.039c0 .187-.135.34-.301.34z",
    fill: "#E2E2E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.05 9.996l.116.182.102.159H22v-.464a.22.22 0 00-.222-.217h-4.51l-.218.34zM16.947 10.724l.321.294h4.51A.22.22 0 0022 10.8v-.463h-4.732l-.121.146-.2.241z",
    fill: "#CE9874"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.147 10.484a.194.194 0 00.12.041H22v-.375h-4.732a.195.195 0 00-.102.029l.102.159-.121.146z",
    fill: "#C6875E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.341 9.364v-.057c0-.215.208-.391.463-.391s.464.176.464.391v4.382h-.927V9.365z",
    fill: "url(#Dry_Food_svg__paint4_linear_1120_204816)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.34 9.307c0-.215.209-.391.464-.391a.54.54 0 01.142.02c-.186.05-.237.198-.237.371v4.382h-.369V9.308z",
    fill: "url(#Dry_Food_svg__paint5_linear_1120_204816)",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.416 13.69V9.307 9.3c.004-.211.211-.384.463-.384.255 0 .463.176.463.391v4.382h-.926z",
    fill: "url(#Dry_Food_svg__paint6_linear_1120_204816)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.489 13.69V9.3c0-.215.209-.39.463-.39.255 0 .463.175.463.39v4.39h-.926z",
    fill: "url(#Dry_Food_svg__paint7_linear_1120_204816)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.563 13.69V9.3c0-.215.209-.39.464-.39.254 0 .462.175.462.39v4.39h-.926z",
    fill: "url(#Dry_Food_svg__paint8_linear_1120_204816)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.416 9.307c0-.215.208-.391.463-.391.05 0 .098.007.142.02-.185.05-.236.198-.236.371v4.382h-.369V9.308z",
    fill: "url(#Dry_Food_svg__paint9_linear_1120_204816)",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.49 9.307c0-.215.209-.391.463-.391.05 0 .097.007.142.02-.186.05-.236.198-.236.371v4.382h-.37V9.308z",
    fill: "url(#Dry_Food_svg__paint10_linear_1120_204816)",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.563 9.307c0-.215.209-.391.464-.391.049 0 .097.007.142.02-.186.05-.237.198-.237.371v4.382h-.369V9.308z",
    fill: "url(#Dry_Food_svg__paint11_linear_1120_204816)",
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.841 14.689h.754a.19.19 0 00.192-.188.19.19 0 00-.192-.188h-.753a.19.19 0 00-.193.188.19.19 0 00.193.188zM14.108 14.689h.753a.19.19 0 00.192-.188.19.19 0 00-.192-.188h-.753a.19.19 0 00-.192.188.19.19 0 00.192.188z",
    fill: "#000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.666 16.902c0-1.099.758-1.989 1.693-1.989.113 0 .223.013.33.038-.757.197-1.324.992-1.324 1.942 0 .966.585 1.77 1.36 1.951a1.46 1.46 0 01-.366.047c-.935 0-1.693-.89-1.693-1.989z",
    fill: "url(#Dry_Food_svg__paint12_linear_1120_204816)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.617 13.313l-3.603.444 1.073 6.456 2.271.186 2.271-.186 1.073-6.456-3.085-.444z",
    fill: "#78CEFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.628 20.213h-4.542v.393a.4.4 0 00.403.394h3.736a.4.4 0 00.403-.394v-.393z",
    fill: "#D1E3EE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.715 13.018a.079.079 0 00-.08.077v.292c0 .203.171.37.38.37h6.687a.375.375 0 00.378-.37v-.292a.078.078 0 00-.079-.077h-7.286z",
    fill: "url(#Dry_Food_svg__paint13_linear_1120_204816)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.05 16.901c0-1.098-.758-1.989-1.692-1.989-.934 0-1.692.89-1.692 1.99 0 1.098.758 1.988 1.692 1.988.934 0 1.692-.89 1.692-1.989z",
    fill: "url(#Dry_Food_svg__paint14_linear_1120_204816)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.323 13.757h-6.309l.112.672h5.901l-.961 5.784h.563l1.073-6.456h-.38z",
    fill: "url(#Dry_Food_svg__paint15_linear_1120_204816)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.002 13.018H18.059c.043 0 .078.034.078.077v.292c0 .203-.17.37-.378.37h.944a.375.375 0 00.378-.37v-.292a.078.078 0 00-.079-.077z",
    fill: "url(#Dry_Food_svg__paint16_linear_1120_204816)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.63 20.606v-.393h-.563v.393a.4.4 0 01-.403.394h.563a.4.4 0 00.403-.394z",
    fill: "url(#Dry_Food_svg__paint17_linear_1120_204816)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.923 17.837a.194.194 0 00.15-.07.184.184 0 00-.03-.264c-.069-.055-.174-.167-.102-.312a3.51 3.51 0 01.088-.167c.151-.271.323-.578-.066-.992a.196.196 0 00-.271-.012.184.184 0 00-.012.265c.203.217.155.303.011.56-.03.055-.064.117-.097.183-.13.265-.049.566.209.767a.195.195 0 00.12.041zM14.908 17.845a.194.194 0 00.15-.07.185.185 0 00-.03-.264c-.069-.054-.174-.167-.103-.312.029-.058.06-.113.089-.166.151-.271.323-.58-.066-.994a.196.196 0 00-.272-.011.184.184 0 00-.012.265c.204.217.155.304.012.561-.03.055-.065.116-.097.183-.13.264-.049.565.208.767a.194.194 0 00.12.041z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint0_linear_1120_204816",
    x1: 10.31,
    y1: 8.464,
    x2: 10.31,
    y2: 16.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0B591"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint1_linear_1120_204816",
    x1: 9.02,
    y1: 8.687,
    x2: 3.621,
    y2: 9.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint2_linear_1120_204816",
    x1: 8.69,
    y1: 11.555,
    x2: 10.828,
    y2: 10.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA9A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint3_linear_1120_204816",
    x1: 11.814,
    y1: 8.463,
    x2: 7.49,
    y2: 9.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint4_linear_1120_204816",
    x1: 16.804,
    y1: 8.916,
    x2: 16.804,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint5_linear_1120_204816",
    x1: 16.643,
    y1: 8.916,
    x2: 16.643,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint6_linear_1120_204816",
    x1: 15.879,
    y1: 8.916,
    x2: 15.879,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint7_linear_1120_204816",
    x1: 14.952,
    y1: 8.909,
    x2: 14.952,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint8_linear_1120_204816",
    x1: 14.026,
    y1: 8.909,
    x2: 14.026,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint9_linear_1120_204816",
    x1: 15.719,
    y1: 8.916,
    x2: 15.719,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint10_linear_1120_204816",
    x1: 14.792,
    y1: 8.916,
    x2: 14.792,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint11_linear_1120_204816",
    x1: 13.866,
    y1: 8.916,
    x2: 13.866,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint12_linear_1120_204816",
    x1: 15.447,
    y1: 19.318,
    x2: 13.596,
    y2: 18.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#F4817F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E6B",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint13_linear_1120_204816",
    x1: 15.358,
    y1: 13.018,
    x2: 15.358,
    y2: 13.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint14_linear_1120_204816",
    x1: 14.442,
    y1: 18.36,
    x2: 15.899,
    y2: 18.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA9A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint15_linear_1120_204816",
    x1: 17.5,
    y1: 16.992,
    x2: 17.323,
    y2: 14.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint16_linear_1120_204816",
    x1: 18.843,
    y1: 13.388,
    x2: 17.462,
    y2: 13.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dry_Food_svg__paint17_linear_1120_204816",
    x1: 17.456,
    y1: 20.607,
    x2: 16.446,
    y2: 20.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })))));
};
export default __webpack_public_path__ + "static/media/Dry Food.c3698313.svg";
export { SvgDryFood as ReactComponent };